<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab title="الدفاع عن الخطة – الدفاع الأول ">
              <app-timeline>
                <app-timeline-item
                  v-for="item in items"
                  :key="item.id"
                  :title="$t(`master.` + item.key)"
                  :subtitle="variant(item) ? 'في انتظار الموافقة ' : 'موافقة '"
                  :time="moment(item.updated_at).fromNow()"
                  :variant="variant(item) ? 'danger' : 'success'"
                />
              </app-timeline>
              <b-spinner
                v-if="load"
                type="grow"
                label="Loading..."
                class="loading"
              />
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <form-wizard
                color="#3a3270"
                :subtitle="null"
                :title="null"
                :finish-button-text="$t('site.finish')"
                :back-button-text="$t('site.back')"
                :next-button-text="$t('site.next')"
                @on-complete="formSubmitted"
                :start-index="tab"
                step-size="sm"
                ref="wizard"
              >
                <b-card>
                  <!-- attach_master_file -->
                  <tab-content
                    :title="$t('master.defend_the_plan')"
                    :before-change="() => validateStep('defend_the_plan')"
                  >
                  
                  <online-session-vue v-if="defend_the_plan"
                      :mediaData="defend_the_plan.online_session"
                      ref="defend_the_plan"
                    ></online-session-vue>
                  </tab-content>
                  <tab-content
                    :title="$t('master.symposium_date')"
                  >
                    <online-session-vue v-if="symposium_date"
                      :mediaData="symposium_date.online_session"
                      ref="symposium_date"
                    ></online-session-vue>
                  </tab-content>
                  <tab-content
                    :title="$t('master.upload_the_three_seasons')"
                   
                  >
                    <b-tabs>
                      <b-tab :title="$t('master.upload_the_three_seasons_1')">
                        <upload
                          datakey="upload_the_three_seasons_1"
                          :files="upload_the_three_seasons_1"
                          :master="masterId"
                      /></b-tab>
                      <b-tab :title="$t('master.upload_the_three_seasons_2')">
                        <upload
                          datakey="upload_the_three_seasons_2"
                          :files="upload_the_three_seasons_2"
                          :master="masterId"
                      /></b-tab>
                      <b-tab :title="$t('master.upload_the_three_seasons_3')">
                        <upload
                          datakey="upload_the_three_seasons_3"
                          :files="upload_the_three_seasons_3"
                          :master="masterId"
                      /></b-tab>
                    </b-tabs>
                  </tab-content>
                </b-card>
              </form-wizard>
            </b-tab>
          </b-tabs>
        </div>

        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import uploadVue from "./wizard/upload.vue";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import Auth from "@/Apis/Auth";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import MastersDataController from "@/Controllers/MastersDataController";
import OnlineSessionVue from "./wizard/OnlineSession.vue";
import SettingController from "@/Controllers/SettingController";
import MastersController from "@/Controllers/MastersController";
import Swal from "sweetalert2";

// Department

export default {
  components: {
    FormWizard,
    TabContent,
    upload: uploadVue,
    AppTimeline,
    AppTimelineItem,
    OnlineSessionVue,
  },
  data() {
    return {
      tab: 0,
      items: [],
      load: true,
      steps : {
        step1 : 0,
        step2 : 0,
      },
      masterId: Auth.MASTER.id,
      symposium_date: { online_session: {} },
      upload_the_three_seasons_1: [],
      upload_the_three_seasons_2: [],
      upload_the_three_seasons_3: [],
      defend_the_plan:{ online_session: {}}
    };
  },
  async created() {
    this.time = await new SettingController().time();

    const timeLine = new MastersController().timeLine();
    const key = timeLine
      .find((a) => a.code == "first_defense")
      .phases.map((a) => {
        return a.code;
      });

    const res = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + this.masterId,
      filterIn: "key|" + key.toString(),
      with: ["mastersData", "onlineSession"],
    });

    this.items = res;
    this.load = false;
    // Step Validation
    const master_key_inst = new MasterKeyStatusController();
    const verfy_step_1 = await master_key_inst.verifyStep(
      "symposium_date",
      this.masterId
    )
    this.steps.step1 = verfy_step_1;


    // End Step Validation
    this.symposium_date = this.getData("symposium_date", 0)[0];
    this.upload_the_three_seasons_1 = this.getData(
      "upload_the_three_seasons_1",
      1,
      true
    );
    console.log( this.upload_the_three_seasons_1);
    this.upload_the_three_seasons_2 = this.getData(
      "upload_the_three_seasons_2",
      1,
      true
    );
    this.upload_the_three_seasons_3 = this.getData(
      "upload_the_three_seasons_3",
      1,
      true
    );
    this.defend_the_plan = this.getData("defend_the_plan", 2)[0];
    this.tab = 0;
    this.$refs["wizard"].changeTab(0, this.tab);
  },
  methods: {
    getData(key, tab, data = false) {
      const find = this.items.filter((a) => a.key == key);
      if (!find) return [];

      this.tab = tab;

      // this.$refs["wizard"].changeTab(0, this.tab);
      if (data) {
        const tt=find.map((a) => a.masters_data);
       
        return tt
      }
      return find;
    },
    variant(item) {
      return item.value == null || item.value == "" || item.value == "-1";
    },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      if (name == "symposium_date") {

        if (this.steps.step1 == 1) return true;
          return this.swalAlert(name);
      }
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return this.swalAlert(name);

    },
     swalAlert(name) {
      
        Swal.fire({
        // position: 'top-start',
        icon: 'error',
        title: 'في انتظار الموافقة علي  ',
       text:  this.$t('master.'+name),
        // text:   'master: ' + name,
       

        showConfirmButton: false,
        timer: 3000,
      })
       
    },
    async formSubmitted() {
      this.$router.push({ name: "Thesis" });
    },
  },
};
</script>

<style>
</style>